import React, { useEffect } from 'react';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#1f2937'
    }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '8px', color: '#111827' }}>
        Terms of Service
      </h1>
      <p style={{ color: '#6b7280', marginBottom: '32px' }}>Last Updated: November 5, 2025</p>

      {/* Add your existing terms sections here */}

      <section style={{ marginBottom: '32px', borderTop: '2px solid #e5e7eb', paddingTop: '32px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '16px', color: '#111827' }}>
          SMS Messaging Terms
        </h2>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Service Description
        </h3>
        <p>
          VinCentrix provides an AI-powered SMS messaging platform that enables automotive dealerships 
          to send automated trade-in offers to their customers.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          User Consent
        </h3>
        <p>
          By providing your mobile phone number to a dealership using VinCentrix services, you agree 
          to receive SMS text messages regarding trade-in offers and vehicle valuations. Consent is 
          not a condition of purchase.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Message Frequency and Charges
        </h3>
        <p>
          Message frequency varies (typically 1-4 messages over 4 days). Message and data rates may 
          apply based on your carrier's plan.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Opt-Out
        </h3>
        <p>
          You may opt out at any time by replying STOP to any message. Upon opt-out, you will receive 
          a confirmation message and will not receive further messages unless you re-consent.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Platform Responsibility
        </h3>
        <p>
          VinCentrix acts as a technology service provider for dealerships. Messages are sent on behalf 
          of dealerships using their brand identity. Questions about specific offers should be directed 
          to the dealership that sent the message.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Prohibited Uses
        </h3>
        <p>Users may not:</p>
        <ul style={{ marginLeft: '20px', marginTop: '12px' }}>
          <li>Use the service to send spam or unsolicited messages</li>
          <li>Harass, abuse, or threaten our staff or AI system</li>
          <li>Attempt to circumvent opt-out mechanisms</li>
          <li>Use the service for any illegal purpose</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Disclaimer
        </h3>
        <p>
          Trade-in offers sent via SMS are estimates based on vehicle data provided. Final offers may 
          vary upon physical inspection. Offers are subject to change and may have expiration dates.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Liability
        </h3>
        <p>VinCentrix is not liable for:</p>
        <ul style={{ marginLeft: '20px', marginTop: '12px' }}>
          <li>Delayed or undelivered messages due to carrier issues</li>
          <li>Inaccuracies in vehicle valuations</li>
          <li>Actions taken by dealerships using our platform</li>
          <li>Charges imposed by mobile carriers</li>
        </ul>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          TCPA Compliance
        </h3>
        <p>
          VinCentrix complies with the Telephone Consumer Protection Act (TCPA). We obtain proper 
          consent before sending messages and honor opt-out requests immediately.
        </p>

        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151', marginTop: '24px' }}>
          Changes to Service
        </h3>
        <p>
          We reserve the right to modify or discontinue SMS services at any time with or without notice.
        </p>
      </section>

      <section style={{ background: '#f3f4f6', padding: '20px', borderRadius: '8px', marginTop: '40px' }}>
        <h3 style={{ fontSize: '1.3rem', marginBottom: '12px', color: '#374151' }}>
          Contact Us
        </h3>
        <p>
          Questions about these Terms of Service?<br />
          Email: <a href="mailto:david@vincentrix.com" style={{ color: '#3b82f6' }}>david@vincentrix.com</a><br />
          Company: VinCentrix, LLC
        </p>
      </section>

    </div>
  );
};

export default TermsOfService;

